"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function () { });
//# sourceMappingURL=noop.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/util/lib/noop.js
// module id = 1137
// module chunks = 37